// extracted by mini-css-extract-plugin
export default {"reportContainer":"CaseReport_reportContainer__NDgUn","headerContainer":"CaseReport_headerContainer__Q-634","dateColumn":"CaseReport_dateColumn__9Zlp7"};